import * as types from './types';

const initialState = {
  userConfig: null,
  loading: false,
  fetched: false,
  success: false,
  fetchConfigError: false,
  savingConfigError: false,
  errors: null,
  sentData: null
};

function userConfigReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USER_CONFIG:
      return {
        ...state,
        loading: true,
        userConfig: null,
        fetched: false,
        fetchConfigError: false,
        success: false
      };

    case types.GET_USER_CONFIG_COMPLETED:
      return {
        ...state,
        loading: false,
        fetched: true,
        userConfig: action.payload
      };

    case types.GET_USER_CONFIG_FAILED:
      return {
        ...state,
        loading: false,
        fetched: true,
        fetchConfigError: true
      };

    // AGREGAR del meta el correo
    case types.PUT_USER_CONFIG:
    case types.PATCH_USER_CONFIG:
      return {
        ...state,
        loading: true,
        success: false,
        savingConfigError: false,
        errors: null,
        sentData: action.meta
      };

    case types.PUT_USER_CONFIG_COMPLETED:
    case types.PATCH_USER_CONFIG_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.PUT_USER_CONFIG_FAILED:
    case types.PATCH_USER_CONFIG_FAILED:
      return {
        ...state,
        loading: false,
        savingConfigError: true,
        errors: action.payload.data.message
      };

    case types.DELETE_USER_CONFIG:
      return {
        ...state,
        loading: true,
        success: false,
        savingConfigError: false,
        errors: null
      };

    case types.DELETE_USER_CONFIG_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.DELETE_USER_CONFIG_FAILED:
      return {
        ...state,
        loading: false,
        savingConfigError: true,
        errors: action.payload
      };

    case types.RESET_USER_CONFIG:
      return {
        ...state,
        success: false,
        fetchConfigError: false,
        savingConfigError: false,
        errors: null,
        sendData: null
      };

    default:
      return state;
  }
}

export default userConfigReducer;
